import { Card, Col, FormGroup, Nav, NavItem, NavLink, Row } from "reactstrap";
import { All, CreateNewProject, Doing, Done, Href } from "../../../Constant";
import { CheckCircle, Info, PlusSquare, Target } from "react-feather";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { setActiveTab } from "../../../Redux-Toolkit/Reducers/ProjectSlice";

export const ProjectListHead = () => {
  const {activeTab} = useAppSelector((state)=>state.project)
const dispatch = useAppDispatch()
  return (
    <>
      <Card>
        <Row>
          <Col md="6" className="p-0 d-flex">
            <Nav tabs className="border-tab" id="top-tab">
              <NavItem><NavLink href={Href} className={activeTab === '1' ? 'active' : ''} onClick={() => dispatch(setActiveTab("1"))}><Target />{All}</NavLink></NavItem>
              <NavItem><NavLink href={Href} className={activeTab === '2' ? 'active' : ''} onClick={() => dispatch(setActiveTab("2"))}><Info />{Doing}</NavLink></NavItem>
              <NavItem><NavLink href={Href} className={activeTab === '3' ? 'active' : ''} onClick={() => dispatch(setActiveTab("3"))}><CheckCircle />{Done}</NavLink></NavItem>
            </Nav>
          </Col>
          <Col md="6">
            <FormGroup className="m-0 me-0"></FormGroup>
            <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/project/create-project`}>
              <PlusSquare />
              {CreateNewProject}
            </Link>
          </Col>
        </Row>
      </Card>
    </>
  );
};
